import React from 'react';

import { Divider } from 'components/TripCard/styles';
import useStoreTranslation from 'hooks/useStoreTranslation';

import ContactButtons from '../../ContactButtons';
import { Title, Message, MessageBold } from '../styles';
import { ExclamationCircleIcon } from './styles';

const ErrorAtSending = () => {
  const { t } = useStoreTranslation();

  return (
    <>
      <ExclamationCircleIcon />
      <Title>{t('customerSupport.errorAtSendingRequest.title')}</Title>
      <Message>
        <MessageBold>{t('customerSupport.errorAtSendingRequest.important')}</MessageBold>{' '}
        {t('customerSupport.errorAtSendingRequest.message')}
      </Message>

      <Divider />

      <ContactButtons />
    </>
  );
};

export default ErrorAtSending;
